import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useProductStore } from '../../ProductProvider';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();

    const imgLocale: any = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898337861/125w_kv.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731922954092/125w_kv_h5.jpg',
        },
    };
    const imgA = imgLocale[locale] || imgLocale.us;
    const { t } = useLang('theProduct.Banner');
    const itemA = {
        title: t('title'),
        desc: t('desc'),
        pc: imgA.pc,
        h5: imgA.h5,
        // btn_text: t('btn'),
        btn_link:
            pageStatus === 'statusA' ? '' : 'https://www.youtube.com/embed/gtxAkmNxMH8?si=MSicapOQhBWL8Dw-&enablejsapi=1&origin=https%3A%2F%2Fwww.ecoflow.com',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...itemA} theme="black" position="hoverL" />
        </div>
    );
}
